module.exports = __webpack_public_path__ + "img/tarqeem.ec4587b1.png";